import Vue from "vue";
import VueI18n from "vue-i18n";
import en from '@/lang/en';
import cs from '@/lang/cs';

Vue.use(VueI18n);

const STORAGE_KEY = 'seowritee_locale';
const supportedLocales = ['en', 'cs'] as const;

function detectLocale(): string {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored && supportedLocales.includes(stored as typeof supportedLocales[number])) {
            return stored;
        }
    } catch { /* ignore */ }
    const nav = (typeof navigator !== 'undefined' ? navigator.language : 'en').toLowerCase();
    return nav.startsWith('cs') ? 'cs' : 'en';
}

function applyDocumentLang(code: string): void {
    if (typeof document !== 'undefined') {
        document.documentElement.lang = code;
    }
}

export function persistLocale(code: string): void {
    try {
        localStorage.setItem(STORAGE_KEY, code);
    } catch { /* ignore */ }
    applyDocumentLang(code);
}

const detectedLocale = detectLocale();
applyDocumentLang(detectedLocale);

const locale = {
    locale: detectedLocale,
    defaultLocale: 'en',
    fallbackLocale: 'en',
    messages: {en, cs}
};

const I18n = new VueI18n({
    ...locale
});

export {locale, I18n};
